import { NetworkInfo } from '@terra-money/wallet-provider'

declare module '@terra-dev/wallet-types/types' {
  interface NetworkInfo {
    fcd?: string
    mantle?: string
  }
}

export type NetworkName = 'mainnet' | 'testnet'

export const constantNetwork: Record<NetworkName, NetworkInfo> = {
  mainnet: {
    name: 'mainnet',
    chainID: 'columbus-5',
    lcd: 'https://lcd.terra.dev',
    fcd: 'https://fcd.terra.dev',
  },
  testnet: {
    name: 'testnet',
    chainID: 'bombay-12',
    lcd: 'https://bombay-lcd.terra.dev',
    fcd: 'https://bombay-fcd.terra.dev',
  },
}

export const defaultNetworkName =
  (process.env.REACT_APP_NETWORK as NetworkName) ?? 'mainnet'
